function SmallButton(props) {
  const { children, onClick, disabled } = props;

  return (
    <button disabled={disabled} type="button" className=" disabled:bg-sentric-milky-orange disabled:text-sentric-orange disabled:pointer-events-none bg-sentric-light-gray text-white active:bg-sentric-dark-gray hover:bg-black font-bold uppercase text-xs px-4 py-2 rounded-full shadow hover:shadow-md disabled:shadow-none outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" onClick={onClick}>{children}</button>
  );
}

export default SmallButton;
